import React, { useState, useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BeforeAfterSlider from '../components/BeforeAfterSlider';
import { beforeAfterPortfolio as initialPortfolio } from '../mock';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PortfolioPage = () => {
  const navigate = useNavigate();
  const [portfolioItems, setPortfolioItems] = useState([]);

  useEffect(() => {
    fetchPortfolio();
  }, []);

  const fetchPortfolio = async () => {
    try {
      const response = await axios.get(`${API}/portfolio`);
      if (response.data && response.data.length > 0) {
        setPortfolioItems(response.data);
      } else {
        setPortfolioItems(initialPortfolio);
      }
    } catch (error) {
      console.error('Error fetching portfolio:', error);
      setPortfolioItems(initialPortfolio);
    }
  };

  return (
    <div className="bg-white min-h-screen">
      <Header />
      
      <section className="pt-32 pb-20 px-6 bg-[#fafafa]">
        <div className="max-w-7xl mx-auto">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center gap-2 text-black/60 hover:text-black transition-colors mb-12 group font-light"
          >
            <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
            <span className="tracking-wide">Back to Home</span>
          </button>

          <div className="text-center max-w-3xl mx-auto">
            <div className="h-px w-16 bg-black/20 mx-auto mb-8" />
            <h1 
              className="text-5xl md:text-6xl font-light mb-6 tracking-wide"
              style={{ fontFamily: 'Georgia, serif' }}
            >
              Before & After
            </h1>
            <p className="text-sm tracking-[0.3em] text-black/50 uppercase font-light">
              Transformations That Speak For Themselves
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-16">
            {portfolioItems.map((item, index) => (
              <div key={item.id} className="space-y-8">
                <BeforeAfterSlider
                  beforeImage={item.beforeImage}
                  afterImage={item.afterImage}
                />

                <div className="text-center">
                  <div className="h-px w-12 bg-black/20 mx-auto mb-6" />
                  <h2 
                    className="text-2xl md:text-3xl font-light mb-4 tracking-wide"
                    style={{ fontFamily: 'Georgia, serif' }}
                  >
                    {item.title}
                  </h2>
                  <p className="text-xs tracking-[0.3em] uppercase text-black/50 mb-6 font-light">
                    {item.category}
                  </p>
                  {item.description && (
                    <p className="text-black/70 leading-relaxed mb-6 font-light text-sm">
                      {item.description}
                    </p>
                  )}
                  {item.results && (
                    <div className="inline-block px-6 py-3 border border-black">
                      <span className="text-sm tracking-[0.2em] uppercase font-light">
                        {item.results}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PortfolioPage;
